import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-compass",
  "use": "icon-compass-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" class=\"bi bi-compass\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-compass\">\r\n  <path fill-rule=\"evenodd\" d=\"M8 16.016a7.5 7.5 0 0 0 1.962-14.74A1 1 0 0 0 9 0H7a1 1 0 0 0-.962 1.276A7.5 7.5 0 0 0 8 16.016zm6.5-7.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z\" />\r\n  <path d=\"M6.94 7.44l4.95-2.83-2.83 4.95-4.949 2.83 2.828-4.95z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/compass.svg
// module id = jlxC
// module chunks = 60